function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Content from './Content';
import { ARROW_LEFT_KEY, ARROW_RIGHT_KEY } from '../../../../../Utils/constant';
import Item from '../../../common/components/Item';
import ItemWrapper from '../../../common/components/ItemWrapper';
import { COLLAPSE_ICON_POSITION } from '../../../common/constants';
import { isDisabled, isKeyMatched } from '../../../common/helper/general';
import { handleExpandCollapse, handleSelectAndClose } from '../../../common/helper/handlers';
import { keyPressFunctions } from '../helper/data';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
function ExplorerItem(props) {
  const {
    treeNode = {},
    onExpand = () => {},
    onSelect = () => {},
    close = () => {},
    hashTable,
    expanded,
    selected,
    setExpanded,
    setSelected,
    ...restProps
  } = props;
  const {
    id: itemId = ''
  } = treeNode;
  const isGroup = Array.isArray(treeNode?.children);
  const isTreeNodeDisabled = isDisabled(!!treeNode?.disabled);
  const isSelected = !isGroup && selected.includes(itemId);
  const callHandleSelect = e => {
    handleSelectAndClose(e, {
      selected,
      expanded,
      hashTable,
      setSelected,
      onSelect,
      itemId,
      close
    });
  };
  const callHandleExpandCollapse = e => {
    handleExpandCollapse(e, keyPressFunctions, {
      expanded,
      selected,
      hashTable,
      setExpanded,
      onExpand,
      itemId
    });
  };
  const handleKeyPress = e => {
    const keysToIgnore = [ARROW_LEFT_KEY, ARROW_RIGHT_KEY];
    // prevent focus from shifting when LEFT/ RIGHT arrow keys are hit
    if (keysToIgnore.includes(e.key)) {
      e.preventDefault();
    }

    // hitting SPACE/ ENTER key should select/ de-select the tree item if it is a leaf, else expand the item if it has children.
    if (!isTreeNodeDisabled && isKeyMatched(e, keyPressFunctions.expand)) {
      isGroup ? callHandleExpandCollapse(e) : callHandleSelect(e);
    }
  };
  const explorerItemContentClasses = classNames({
    [treeStyles['sib-tree-view__exp-item-content']]: true,
    [treeStyles['sib-tree-view__exp-item-content--selected']]: isSelected
  });
  return /*#__PURE__*/React.createElement(ItemWrapper, _extends({
    itemId: itemId,
    className: treeStyles['sib-tree-view__exp-item'],
    disabled: isTreeNodeDisabled,
    ariaAttributes: {
      'aria-selected': isSelected
    },
    onClick: isGroup ? callHandleExpandCollapse : callHandleSelect,
    onKeyDown: handleKeyPress
  }, restProps), /*#__PURE__*/React.createElement(Item, {
    className: explorerItemContentClasses,
    treeNode: treeNode,
    disabled: isTreeNodeDisabled,
    showCollapseIcon: Array.isArray(treeNode?.children),
    collapseIconPos: COLLAPSE_ICON_POSITION.RIGHT,
    isCollapseIconExpanded: false,
    iconColor: "var(--sib-color_content-secondary)"
  }, /*#__PURE__*/React.createElement(Content, {
    label: treeNode.label,
    tagMetaData: treeNode.tagMetaData,
    icon: treeNode.icon,
    helpText: treeNode.helpText,
    isGroup: isGroup
  })));
}
ExplorerItem.propTypes = {
  treeNode: PropTypes.object,
  onExpand: PropTypes.func,
  onSelect: PropTypes.func,
  close: PropTypes.func,
  hashTable: PropTypes.object,
  expanded: PropTypes.array,
  selected: PropTypes.array,
  setExpanded: PropTypes.func,
  setSelected: PropTypes.func
};
export default ExplorerItem;